module.exports = __webpack_public_path__ + "static/media/logos-harineraguadalupe.92c41af3.png";